import { render, staticRenderFns } from "./PluggableAsDialog.vue?vue&type=template&id=c5166be2&"
import script from "./PluggableAsDialog.vue?vue&type=script&lang=js&"
export * from "./PluggableAsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports